<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Aandeelhouder
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vermeld de naam van de aandeelhouder en een (Nederlands) fiscaal nummer BSN). Als er sprake is van een
                aandelenbezit minder dan 5% of van een buitenlandse identificatie dan mag het veld leeg gelaten worden.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Percentage aandelen
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vermeld per aandeelhouder de omvang van het belang, in procenten in 2 decimalen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3"
                    aria-expanded="false" aria-controls="collapse3">
                Bedrag dividend
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vermeld per aandeelhouder de bruto opbrengst in hele euro's.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4"
                    aria-expanded="false" aria-controls="collapse4">
                Aanmerkelijk belang (minimaal 5%)
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je hebt een aanmerkelijk belang als je, eventueel samen met je fiscale partner, direct of indirect,
                minimaal 5% hebt van:<br/>
                <ul>
                    <li>de aandelen, winstbewijzen, genotsrechten of opties op aandelen in een binnen- of buitenlandse
                        vennootschap. Dit geldt ook als u 5% hebt van een bepaald soort aandelen.
                    </li>
                    <li>het stemrecht in een coöperatie of in een vereniging op coöperatieve grondslag</li>
                </ul>
                Voorbeelden van binnenlandse vennootschappen zijn de naamloze vennootschap (nv), de besloten
                vennootschap (bv) en de commanditaire vennootschap (cv).
                <div class="space20"></div>

                <b>Familieleden</b><br/>
                Heb je zelf minder dan 5% van de aandelen, opties of winstbewijzen in een binnenlandse
                vennootschap of coöperatie? Maar hebben je familieleden in dezelfde vennootschap of coöperatie wél een
                aanmerkelijk belang? Dan heb je toch een aanmerkelijk belang. Het gaat hier om familieleden in de rechte
                lijn van jezelf en ujew fiscale partner zoals ouders, kinderen en kleinkinderen. Het kan ook gaan om de
                fiscale partners van deze familieleden in de rechte lijn.
            </div>
        </div>
    </div>
</div>
